import React from "react";

interface CardSectionProps {
  title?: string;
  children: React.ReactNode;
  span?: number;
  columns?: number;
  bordered?: boolean;
  className?: string;
}

const CardSection: React.FC<CardSectionProps> = ({
  title,
  children,
  span = 12,
  columns = 12,
  bordered = true,
  className = "",
}) => {
  const baseStyles = bordered
    ? "bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-md p-4"
    : "";

  return (
    <div
      className={`grid gap-4 ${baseStyles} ${className}`}
      style={{
        gridColumn: `span ${span}`,
        gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
      }}
    >
      {title && (
        <h2 className="text-lg font-semibold col-span-full mb-2 text-gray-900 dark:text-gray-100">
          {title}
        </h2>
      )}
      {children}
    </div>
  );
};

export default CardSection;